var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConvertArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.19,
    height: 15.435,
    viewBox: "0 0 20.19 15.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26240",
    "data-name": "Group 26240",
    transform: "translate(22.69 29.135) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37668",
    "data-name": "Path 37668",
    d: "M2.946,22.477,9.173,28.7a1.488,1.488,0,0,0,2.1-2.1L7.6,22.9H21.2a1.488,1.488,0,0,0,0-2.975H7.6l3.677-3.677a1.5,1.5,0,1,0-2.125-2.1L2.946,20.352A1.513,1.513,0,0,0,2.5,21.415,1.429,1.429,0,0,0,2.946,22.477Z",
    fill: "#ccc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertArrow);
export default __webpack_public_path__ + "static/media/convert-arrow.e4f5b2f3558b826de356872a24ffd50f.svg";
export { ForwardRef as ReactComponent };